import { ArticleTypeCode } from '@/types/article'
import { Config } from './types'

export const enabledStars = true
export const enabledArticleIssue = true
export const canDisableInitialCap = false
export const enabledTrueLieWidget = false
export const canSendToKadam = false
export const enabledRelatedArticles = false
export const enabledInviteDiscussion = true

export const defaultSectionId: Config['defaultSectionId'] = ({ type }) => {
  return type === ArticleTypeCode.NEWS ? 111 : null
}

export const canSendToMarketing: Config['canSendToMarketing'] = () => {
  return false
}

export const articleTitleMaxLength: Config['articleTitleMaxLength'] = ({
  type,
}) => {
  if (type === ArticleTypeCode.VIDEO) {
    return 100
  }

  return 120
}

export const articlePreviewMaxLength: Config['articlePreviewMaxLength'] = () =>
  1000

export const enabledExtraArtcleInfo: Config['enabledExtraArtcleInfo'] = () => {
  return false
}
